import React, { useState } from "react";
import Button from "../../Components/Button";
import Modal from "../../../../../../components/ui/Modal/Modal";
import QRScanTable from "../../Components/QRScanTable";
import { ImArrowRight } from "react-icons/im";
import { useUpdateProductLots } from "../../../../../../api/inventory/use-update-lot";

const InventodyLinkageModal = (props) => {
  const {
    onCloseLinkageModal,
    productData,
    qrData,
    id,
    setTriggerCloseLinkageModal,
    setTriggerCloseDataModal,
  } = props;
  const [warehouseQty, setWarehouseQty] = useState(0);
  const hasData = true;
  const isSubmitDisable = warehouseQty === 0 || !warehouseQty;
  const { mutate: updateProductLots } = useUpdateProductLots();

  const onChangeQty = (e) => {
    setWarehouseQty(e.target.value);
  };

  const handleSubmit = async () => {
    if (!isSubmitDisable) {
      await updateProductLots({
        id: id,
        qnt: warehouseQty,
        qntType: "IN",
      });
      setTriggerCloseLinkageModal(true);
      setTriggerCloseDataModal(true);
    }
  };

  return (
    <div className="w-[48rem]">
      <div className="flex items-center justify-between pb-[8px] border-b border-b-primary-grey">
        <h1 className="text-[16px] px-5 font-bold">
          수동 등록 - LOT 재고 연동
        </h1>
        <div>
          <button
            onClick={onCloseLinkageModal}
            className="border mr-2 px-6 py-1 border-button-grey rounded-[4px]"
          >
            취소
          </button>
          <Modal
            childrenWidth="inline"
            description={
              <span>
                해당 상품을 입고수량으로 연동하시겠습니까?
                <br /> 최종적으로 입고수량이 맞는 지 확인하신 후, 연동하기를
                눌러주세요.
                <br />
                연동하게 되면 재고가 등록되어 ‘총 입고수량’ 에 계산됩니다.
              </span>
            }
            onSubmit={handleSubmit}
          >
            <button
              disabled={isSubmitDisable}
              className={`border mr-5 px-6 py-1 border-button-grey ${
                isSubmitDisable
                  ? "text-disable-black bg-button-grey"
                  : "text-white bg-primary-blue"
              } rounded-[4px]`}
            >
              연동 완료{" "}
            </button>
          </Modal>
        </div>
      </div>
      <div className="px-5 py-4">
        <div>
          <div className="border py-2 px-4 text-white border-primary-blue bg-primary-blue">
            상품정보
          </div>
          <div className="flex w-full">
            <div className="flex w-[50%]">
              <h1
                className={`border py-2 w-28 px-4 border-r-0 border-disable-grey bg-input-grey flex-none`}
              >
                카테고리
              </h1>
              <div className="flex items-center border-disable-grey px-2 outline-none border-r-0 border w-full">
                {productData?.productGroup?.productGroupCategory?.name}
              </div>
            </div>
            <div className="flex w-[50%]">
              <h1
                className={`border py-2 w-28 px-4 border-r-0 border-disable-grey bg-input-grey flex-none`}
              >
                REF(상품코드)
              </h1>
              <div className="flex items-center border-disable-grey px-2 outline-none w-full border">
                {productData?.ref}
              </div>
            </div>
          </div>
          <div className="flex w-full">
            <h1 className="border border-t-0 py-2 w-28 flex-none px-4 border-r-0 border-disable-grey bg-input-grey">
              상품명
            </h1>
            <div className="flex items-center border-disable-grey border-t-0 px-2 outline-none w-full border">
              {productData?.name}
            </div>
          </div>
        </div>
        <div className="w-full mt-4">
          <Modal
            hasCancel={false}
            // description={<QRScanModal dataQr={dataQr} />}
            description={
              <span>
                해당 상품명과 REF가 일치하지 않습니다. 일치하는 상품으로 다시
                <br />
                스캔해주세요.
              </span>
            }
          >
            <Button
              backgroundColor={`bg-drop-yellow border border-drop-yellow`}
              fontWeight={`font-bold text-sm`}
              padding={`py-2 `}
              width={`w-full`}
              titleButton={`QR 스캔`}
            />
          </Modal>
        </div>
      </div>
      <div className="mt-2 border-t-8 border-line-grey px-5">
        {hasData ? (
          <>
            <div className="mt-6 py-2 px-4 text-white border-primary-blue bg-primary-blue">
              QR 스캔 정보
            </div>
            <QRScanTable qrData={qrData} />
            <div className="flex gap-8 mt-4 items-center">
              <div className="border border-[#dddddd] w-[10rem] text-center">
                <div className="border-b border-[#dddddd] bg-[#f2f2f4] p-3 w-full mx-auto">
                  현재 재고수량
                </div>
                <div className="p-3 w-full mx-auto">{qrData?.qnt}</div>
              </div>
              <ImArrowRight className="text-[42px]" />
              <div className="flex w-full">
                <div className="border border-[#dddddd] w-[60%] text-center">
                  <div className="border-b border-[#dddddd] bg-[#f2f2f4] p-3 w-full mx-auto">
                    입고수량{" "}
                  </div>
                  <div className="py-2 px-3 w-full mx-auto">
                    <input
                      type="number"
                      className="rounded-[4px] border border-[#dddddd] p-1 w-full focus:outline-none"
                      value={warehouseQty}
                      onChange={onChangeQty}
                    />
                  </div>
                </div>
                <div className="border-t border-r border-b border-[#dddddd] w-[40%] text-center">
                  <div className="border-b border-[#dddddd] bg-[#f2dca8] p-3 w-full m-auto">
                    입고 후 현재 재고수량
                  </div>
                  <div className="p-3 w-full m-auto font-bold">
                    {+qrData?.qnt + +warehouseQty}
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="text-title-grey justify-center pt-20 pb-28 flex items-center">
              출고 상품의 QR을 스캔해주세요.
            </div>
            <div className="text-title-grey pb-4">
              <p className="font-bold">※ 사용방법 안내</p>
              <p>
                1. QR 스캔을 누룬 후, USB 바코드 스캐너를 통하여 '입고 상품의
                QR'을 스캔해주세요.
              </p>
              <p>
                2. QR 스캔이 일치되면, 해당 REF에 연동된 'QR 스캔 정보'가
                나옵니다.
              </p>
              <p>3. 적용 결과에 출고수량을 정확히 입력해주세요. </p>
              <p>
                4. 출고된 수량을 잘못 입력할 경우, 해당 LOT 재고는 '재고 수동
                변경'을 통해 재고 수량을 조정할 수 있습니다.
              </p>
              <p>단, 현재 단계에서 신중히 입력 부탁드립니다.</p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default InventodyLinkageModal;
